// extracted by css-extract-rspack-plugin
export default {"sortIcon":"icons-module__sortIcon__TE1Bosb"};